import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

type ClientLogLevel = 'error' | 'warn' | 'info';

/**
 * Ships browser-side logs to the backend /client-log sink so frontend errors
 * are reviewable in CloudWatch alongside the API logs. Fire-and-forget.
 */
@Injectable({ providedIn: 'root' })
export class ClientLogService {
  private readonly url = `${environment.apiUrl}/client-log`;

  constructor(private readonly http: HttpClient) {}

  log(level: ClientLogLevel, message: string, stack?: string): void {
    const payload = {
      app: 'web',
      level,
      message: (message ?? '').toString().slice(0, 4000),
      url: typeof location !== 'undefined' ? location.href : '',
      stack: (stack ?? '').slice(0, 8000),
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    };
    this.http.post(this.url, payload).subscribe({ error: () => {} });
  }
}
